import { render, staticRenderFns } from "./BeaufschlagtePreisdaten.vue?vue&type=template&id=e770933a"
import script from "./BeaufschlagtePreisdaten.vue?vue&type=script&lang=js"
export * from "./BeaufschlagtePreisdaten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e770933a')) {
      api.createRecord('e770933a', component.options)
    } else {
      api.reload('e770933a', component.options)
    }
    module.hot.accept("./BeaufschlagtePreisdaten.vue?vue&type=template&id=e770933a", function () {
      api.rerender('e770933a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BeaufschlagtePreisdaten.vue"
export default component.exports